/*
 * @Author: your name
 * @Date: 2021-06-25 11:16:28
 * @LastEditTime: 2021-06-25 14:06:37
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\public\px2rem.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
export const rem =  function (window, document) {
    var viewWidth = 375;
    // var pick = viewWidth / 10;
    var mode = "resize";
    function change() {
        var view = document.documentElement.clientWidth || window.innerWidth;
        console.log(view)
        // 如果视图窗口 宽度大于 720 px
        // if (view >= 1920) {
        //     // 那么设置 html 的font-size 为100px
        //     document.getElementsByTagName("html")[0].style.fontSize = 100 + "px";
        //     return;
        // }

        // 否则 设置html 的font-size 为动态的值 = 视图窗口宽度 / 100px
        document.getElementsByTagName("html")[0].style.fontSize =
            view / viewWidth*16 + "px";
    }
    window.addEventListener(mode, change, !1);
    window.document.addEventListener("DOMContentLoaded", change, !1);
};
